import React, { useState, useEffect } from 'react';
import { MapPin, Navigation } from 'lucide-react';
import { fetchTravelInfo } from '../../lib/utils';

const CompactTravelIndicator = ({ lat1, lon1, lat2, lon2 }) => {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (lat1 && lat2) {
      setLoading(true);
      fetchTravelInfo(lat1, lon1, lat2, lon2).then(res => {
        setInfo(res);
        setLoading(false);
      });
    } else {
      setInfo(null);
    }
  }, [lat1, lon1, lat2, lon2]);

  if (loading) return <div style={{ fontSize: 10, color: '#94a3b8', fontStyle: 'italic', display: 'flex', alignItems: 'center', gap: 6 }}><div className="w-spinner-mini" /> Calcul trajet...</div>;
  if (!info) return null;

  const isLong = info.duration > 45;

  return (
    <div style={{ 
      display: 'flex', alignItems: 'center', gap: 10, 
      background: isLong ? '#fff7ed' : '#f0fdf4', 
      border: '1px solid ' + (isLong ? '#ffedd5' : '#dcfce7'),
      padding: '8px 12px', borderRadius: 12, marginTop: 8
    }}>
      <MapPin size={14} style={{ color: isLong ? '#f97316' : '#22c55e' }} />
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 11, fontWeight: 800, color: '#0f172a' }}>
          {info.duration} min <span style={{ color: '#94a3b8', fontSize: 10 }}>({info.distance} km)</span>
        </div>
      </div>
      <a 
        href={`https://waze.com/ul?q=${lat2},${lon2}&navigate=yes`} 
        target="_blank" rel="noreferrer" 
        style={{ display: 'flex', alignItems: 'center', gap: 4, background: '#fff', border: '1.5px solid #e2e8f0', padding: '4px 8px', borderRadius: 8, fontSize: 10, fontWeight: 900, color: '#0f172a', textDecoration: 'none' }}
        onClick={e => e.stopPropagation()}
      >
        Lancer Waze
      </a>
    </div>
  );
};

export default CompactTravelIndicator;
